module.exports = __webpack_public_path__ + "static/media/tabs-icon-01.4ace2aac.svg";